import { append, classList, cloneNode, removeChildNodes } from "@acng/frontend-bounty";
import { ResourceUtility } from "./resource.js";
import { REGISTRY_ELEMENT } from "../resource.js";
import { element, nodes, render, scope } from "../../service/render.js";
const rendering = Symbol();
export class TemplateUtility extends ResourceUtility {
    /**
     * @type {import("../../service/render").RenderingContext}
     */
    [rendering] = {
        [REGISTRY_ELEMENT]: this[REGISTRY_ELEMENT],
        [scope]: undefined,
    };
    /**
     * @returns {import("../../service/render").Nodes | undefined}
     */
    get nodes() {
        return this[rendering][nodes];
    }
    clone() {
        return cloneNode(this[REGISTRY_ELEMENT].content);
    }
    /**
     * @template {HTMLElement} T
     *
     * @param {T} target
     *
     * @param {import("../../service/render").Scope} [params]
     *
     * @param {(
     *   target: T,
     *   nodes: import("../../service/render").Nodes,
     * ) => void} [callback]
     *
     * @returns {T}
     */
    toElement(target, params, callback) {
        const r = this[rendering];
        r[scope] = params ?? {};
        r[element] = target;
        r[nodes] = {};
        DEBUG: if (r[REGISTRY_ELEMENT].hasAttribute("debug")) {
            target.setAttribute("debug", "");
        }
        const fragment = render(r);
        callback?.(target, r[nodes]);
        removeChildNodes(target);
        append(target, fragment);
        return target;
    }
    /**
     * @deprecated
     */
    get classList() {
        return this[REGISTRY_ELEMENT].classList;
    }
    /**
     * @param {import("../../service/render").Scope} [params]
     * @returns {string}
     */
    toText(params) {
        const r = this[rendering];
        r[scope] = params;
        return render(r).textContent ?? "";
    }
}
